export default __webpack_public_path__ + "static/media/offre-1.66befc12.png";